<template>
  <div>
    <pack>
      <el-breadcrumb separator="/" class="pt12 pb12">
        <el-breadcrumb-item :to="`/home?cat_id=${cat.id}`">{{cat.name}}</el-breadcrumb-item>
        <el-breadcrumb-item>正文</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="ft-title">{{info.title}}</div>
      <div class="text-placeholder mt4">{{info.add_time | day_normal}}</div>
      <div class="content mt24" v-html="info.content"></div>
    </pack>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {supplier_help_detail} from '@api/detail'
import format from '@utils/format'
export default {
  components: {
    
  },
  props: {
    
  },
  data: () => ({
    info: {
      add_time: '',
      cid: '',
      content: '',
      hits_num: '',
      hot: '',
      id: '',
      sort: '',
      title: '',
      update_time: '',
    },

  }),
  computed: {
    ...mapState([
      'menuList',
      'articleList',
    ]),

    id() {
      return this.$route.query.id
    },

    cat_id() {
      return this.info.cid || ''
    },

    cat() {
      let cur
      this.getTree(this.menuList, 'child_list', (item) => {
        if(item.id == this.cat_id) {
          cur = item
        }
      })
      return cur || {}
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        let id = this.id
        if(id) {
          this.getInfo(id)
        }
      }
    }
  },

  methods: {
    getTree(tree, nodeName, fn) {
      tree.forEach(item => {
        fn(item)
        if(item[nodeName]) {
          this.getTree(item[nodeName], nodeName, fn)
        }
      })
    },

    async getInfo(id) {
      let {data} = await supplier_help_detail({id})
      this.$validateRes(data)
        .then(() => {
          this.info = data.info
          this.$store.commit('SET_MENU_DEFALT_ACTIVE', this.cat_id)
        })
       
    }
  },
  filters: {
    day_normal: format.day_normal
  },
}
</script>

<style lang="scss" scoped>
  
</style>